<template>
  <div class="euclid cypress-hook--offers-modal">
    <inquire-phone-number
      v-if="modalCurrentUiState === 'inquiry'"
      @update-phone="$emit('update-phone', $event)"></inquire-phone-number>
    <Modal
      v-if="modalCurrentUiState === 'review'"
      :closable="false"
      :shouldLimitHeight="false"
      :shouldNotHavePadding="true"
      modalSize="slender">
      <div class="grid offer">
        <h5 class="header">{{agreementDisplayLabel}}</h5>
        <div class="detail">
          <h1 class="subheader">Homeowner Offers: Fast and Free Quotes</h1>
          <p class="leader" v-html="agreement.displayText"></p>
          <div class="inputs">
            <v-checkbox
              class="input"
              color="#0e74fe"
              hide-details
              v-for="offer in agreement.offers"
              :key="offer.sortOrder"
              v-model="verticalIds[offer.verticalIds]">
              <template slot="prepend">
                <v-icon color="#ff760a" class="ornament">arrow_upward</v-icon>
              </template>
              <template slot="label">
                <span class="label" v-html="offer.displayText"></span>
              </template>
            </v-checkbox>
          </div>
        </div>
        <div class="controls">
          <v-btn
            @click="$emit('submit-agreement')"
            :disabled="selectedVerticalIds.length === 0"
            color="#ff760a"
            class="control--yes white--text"
            plain>{{ buttonTextContinue }}</v-btn>
            <v-btn
              @click="$emit('cancel-offers')"
              class="control--no"
              flat
              color="#333">
              <u>{{ buttonTextCancel }}</u>
            </v-btn>
        </div>
        <div class="disclaimers">
          <p class="legal" v-html="agreement.displayFinePrint"></p>
          <offers-policies font-color="white" :embolden="true"></offers-policies>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Shared/Modal.vue';
import InquirePhoneNumber from '@/components/OffersModalTemplates/shared/InquirePhoneNumber.vue';
import OffersPolicies from '@/components/OffersModalTemplates/shared/OffersPolicies.vue';

export default {
  components: { Modal, InquirePhoneNumber, OffersPolicies },
  props: [
    'agreement',
    'modalCurrentUiState',
    'verticalIds',
    'selectedVerticalIds',
    'buttonTextCancel',
    'buttonTextContinue',
  ],
  computed: {
    agreementDisplayLabel() {
      return this.agreement.displayLabel ? this.agreement.displayLabel : 'Agreements and Offers';
    },
  },
};
</script>
<style lang="scss" scoped>
.euclid {
  .grid {
    color: #404040;
    height: 100%;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 40px 1fr auto auto;
    grid-template-areas:
      'header'
      'detail'
      'controls'
      'disclaimers';

    padding: 0;
    max-height: 600px;
    height: 600px;
    overflow: hidden;
    min-height: -webkit-fill-available;
  }
  .header {
    align-items: flex-end;
    color: #808080;
    display: flex;
    font-family: 'Barlow Semi Condensed', sans-serif;
    font-size: 13.5px;
    font-weight: 400;
    grid-area: header;
    height: 100%;
    justify-content: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    margin-top: 16px;
  }

  .detail {
    grid-area: detail;
    height: 100%;
    overflow-y: auto;
    .input {
      color: black;
    }
  }

  .controls {
    grid-area: controls;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
    [class^='control'] {
      padding: 20px;
      &.control--yes {
        font-size: 18px;
        font-weight: 600;
      }
      &.control--no {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .disclaimers {
    grid-area: disclaimers;
  }
  .header,
  .leader,
  .detail,
  .controls {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
